import { ACTION_RESET_LOADER, ACTION_SET_LOADER, type LoaderActionTypes, type NewLoaderState } from '../types/loader';

export function setLoader(state: NewLoaderState): LoaderActionTypes {
    return {
        type: ACTION_SET_LOADER,
        state,
    };
}

export function resetLoader(): LoaderActionTypes {
    return {
        type: ACTION_RESET_LOADER,
    };
}
